import { Breadcrumbs } from "../../../AbstractElements";
import { Container, Row } from "reactstrap";
import { SizesCart } from "./Sizes";
import StatusIndicatorCart from "./StatusIndicator/index";
import ShapsCart from "../Avtars/Shaps/index";
import RatioCart from "../Avtars/Ratio/index";
import GroupingCart from "../Avtars/Grouping/index";

const AvatarsContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle="Avatars" parent="Ui Kits" title="Avatars" />
      <Container fluid>
        <div className="user-profile">
          <Row>
            <SizesCart />
            <StatusIndicatorCart />
            <ShapsCart />
            <RatioCart />
            <GroupingCart />
          </Row>
        </div>
      </Container>
    </>
  );
};

export default AvatarsContainer;
